import * as CryptoJS from "crypto-js";

class FileHashUtils {
  /*
   * Generate a hash for a file using SHA-256.
   * @param {File} file - The file to hash.
   * @returns {Promise<string>} The hash of the file.
   */
  static async generateFileHash(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const arrayBuffer = event.target?.result as ArrayBuffer;
        const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
        const hash = CryptoJS.SHA256(wordArray).toString();
        resolve(hash);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  }
}

export default FileHashUtils;
